import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OwnerState {
  accessToken: string;
  refreshToken: string;
}

const initialState: OwnerState = {
  accessToken: "",
  refreshToken: "",
};

const ownerSlice = createSlice({
  name: "owner",
  initialState,
  reducers: {
    loginOwner(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    logoutOwner(state) {
      state.accessToken = "";
      state.refreshToken = "";
    },
  },
});

export const { loginOwner, logoutOwner } = ownerSlice.actions;
export default ownerSlice.reducer;
